<template>
    <ButtonGroup
        :buttons="arrivalDateModes"
        name="arrivalDateSelectionMode"
        :value.sync="selectedMode"
        required
        class="arrival-date-mode"
    >
        <template #nodate="mode">
            <div class="arrival-date-mode__header">
                <span class="arrival-date-mode__header-text">{{ $t('Checkout.arrivalDateMode.nodate.header') }}</span>
                <IconSvg
                    filepath="arrow-down.svg"
                    class="arrival-date-mode__header-icon"
                    :class="{ 'arrival-date-mode__header-icon--active': selectedMode === mode.item.value }"
                />
            </div>

            <TransitionExpand>
                <div v-if="selectedMode === mode.item.value" class="arrival-date-mode__body">
                    {{ $t('Checkout.arrivalDateMode.nodate.text') }}
                </div>
            </TransitionExpand>
        </template>

        <template #date="mode">
            <div class="arrival-date-mode__header">
                <span class="arrival-date-mode__header-text">{{ $t('Checkout.arrivalDateMode.date.header') }}</span>
                <IconSvg
                    filepath="arrow-down.svg"
                    class="arrival-date-mode__header-icon"
                    :class="{ 'arrival-date-mode__header-icon--active': selectedMode === mode.item.value }"
                />
            </div>

            <TransitionExpand>
                <div v-if="selectedMode === mode.item.value" class="arrival-date-mode__body">
                    <p>{{ $t('Checkout.arrivalDateMode.date.text') }}</p>

                    <ArrivalDateSelection
                        :productVariantId="productVariantId"
                        :checkinDates.sync="dates"
                        :additional-information.sync="additionalInfo"
                        :duration="nights"
                        datepicker-placeholder="Checkout.arrivalDateMode.date.placeholder"
                        :additional-information-visible="additionalInformationVisible"
                    />

                    <p class="mb-0">
                        {{ $t('Checkout.delayPayment.notice') }}
                    </p>
                </div>
            </TransitionExpand>
        </template>
    </ButtonGroup>
</template>

<script>
import ButtonGroup from '@/components/ButtonGroup';
import ArrivalDateSelection from '@/components/checkout/ArrivalDateSelection';
import TransitionExpand from '@/components/utility/TransitionExpand';
import ArrivalDateSelectionModes from '@/models/ArrivalDateSelectionModes';

const modes = Object.values(ArrivalDateSelectionModes);

export default {
    name: 'ArrivalDateMode',
    components: { TransitionExpand, ArrivalDateSelection, ButtonGroup },

    props: {
        productVariantId: {
            type: [String, Number],
            required: true
        },
        nights: {
            type: Number,
            required: true
        },
        checkinDates: Array,
        additionalInformation: String,
        additionalInformationVisible: Boolean,
        arrivalDateMode: String
    },

    computed: {
        arrivalDateModes() {
            return modes.map(m => ({ value: m }));
        },
        dates: {
            get() {
                return this.checkinDates;
            },
            set(value) {
                this.$emit('update:checkinDates', value);
            }
        },
        additionalInfo: {
            get() {
                return this.additionalInformation;
            },
            set(value) {
                this.$emit('update:additionalInformation', value);
            }
        },
        selectedMode: {
            get() {
                return this.arrivalDateMode;
            },
            set(value) {
                this.$emit('update:arrivalDateMode', value);
            }
        }
    }
};
</script>

<style scoped lang="scss">
.arrival-date-mode {
    display: flex;
    justify-content: flex-start;
    flex-direction: column;

    &__header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    &__header-text {
        text-wrap: balance;
        text-align: left;
    }

    &__header-icon {
        font-size: 20px;
        min-width: 1em;

        &--active {
            transform: rotate(180deg);
        }
    }

    &__body {
        text-align: left;
        line-height: 1.3em;
        margin-top: 10px;
        padding-top: 10px;
        border-top: 1px solid var(--border-color);
    }

    &__body ::v-deep .calendar-icon {
        height: 20px;
    }
}
</style>
